import { Component } from '@angular/core';
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {FilesService} from "../../services/files/files.service";
import {IconsService} from "../../services/icons.service";
import {ChatsService} from "../../services/chats.service";
import * as UserSelectors from "../../state/users/users.selector";
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {NgIf} from "@angular/common";
import {ProfileImageComponent} from "../profile-image/profile-image.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {settings} from "../../settings/settings";
import {ClipboardModule} from "@angular/cdk/clipboard";
import { Clipboard } from '@angular/cdk/clipboard';
import {interfaceActions} from "../../state/interface/interface.actions";


@Component({
  selector: 'context-share',
  standalone: true,
  imports: [
    Base64ImageComponent,
    NgIf,
    ProfileImageComponent,
    FaIconComponent,
    ClipboardModule
],
  templateUrl: './context-share.component.html',
  styleUrl: './context-share.component.scss'
})
export class ContextShareComponent {

  objectType: string = "user"
  coord: string = ""
  entityId: string = ""

  constructor(
      private store: Store,
      private route: ActivatedRoute,
      private fileService: FilesService,
      protected iconsService: IconsService,
      private chatService: ChatsService,
      private router: Router,
      private clipboard: Clipboard
  ) {
    this.route.queryParams.subscribe(params => {
      this.objectType = params["shareType"];
      this.coord = params["shareCoord"];
      this.entityId = params["shareEntityId"];
    });
  }

  async shareCoordinate() {
    const link = settings.appBaseUrl + "?coord="+this.coord
    this.clipboard.copy(link)
    this.store.dispatch(interfaceActions.closeContextMenu())
  }

  shareObject() {

  }
}
